import { Container } from '@components/shared/container'
import { Card, CardContent } from '@components/ui/card'

export const RawError = () => (
  <Container size={'sm'} className="xs:mt-24">
    <Card className="p-16 !bg-white">
      <CardContent className="text-center">
        <img
          src={'/images/errors/internal-server-error.svg'}
          alt={'error'}
          width={360}
          height={240}
          className="mx-auto scale-75 xs:scale-100"
        />
        <p className="mt-16 text-h3 xs:text-h2">Oops! Internal Server Error</p>
        <p className="mt-3 text-body2 xs:text-body1">
          It seems like we’re having some difficulties with the server.
        </p>
      </CardContent>
    </Card>
  </Container>
)
